import dayjs from "dayjs";

export function formatDate(date?: Date | string | null) {
  if (!date) return "";
  return dayjs(date).format("DD/MM/YYYY");
}

export function formatDatetime(date?: Date | string) {
  if (!date) return "";
  return dayjs(date).format("DD/MM/YYYY HH:mm");
}

interface User {
  person?: {
    firstname?: string | null;
    lastname?: string | null;
  } | null;
}

export function formatUserName(user?: User | null) {
  if (!user) return "";
  return `${user.person?.firstname || ""} ${user.person?.lastname || ""}`;
}
